export const CHANNEL_PRODUCT_LIST_TAB = {
  field: 'is_product_linked',
  multiSelect: false,
  tabs: [
    { key: 'Linked', label: 'Linked', value: 'true' },
    { key: 'UnLinked', label: 'UnLinked', value: 'false' },
  ],
};
